import { baseRoutes } from "@/api/base-routes";
import { packNetAxios } from "@/lib/api-client";

const lantechCaseSealerApi = `${baseRoutes.lantechCaseSealer}/api/v1/machines`;

export async function deleteLantechCaseSealerMachine(id: string): Promise<void> {
	await packNetAxios.delete(`${lantechCaseSealerApi}/${id}`);
}

export async function getVersion(): Promise<string> {
	const response = await packNetAxios.get<string>(`${baseRoutes.lantechCaseSealer}/api/v1/version`);
	return response.data;
}
